import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';
import { immerable } from 'immer';

import dayjs from '../../../../core/configs/dayjs';

interface IConsumerMetadataItem {
	id: number;
	creationDate: dayjs.Dayjs | null;
	updateDate: dayjs.Dayjs | null;
	login: string;
	firstName: string;
	lastName: string;
	mail: string;
	avatar: AvatarEntity | null;
	name: string;
	description: string;
	isGroup: boolean;
}

type UserConsumerMetadata = Omit<IConsumerMetadataItem, 'name' | 'description'>;

type GroupConsumerMetadata = {
	id: number;
	name: string;
	description: string;
	creationDate: dayjs.Dayjs | null;
	updateDate: dayjs.Dayjs | null;
};

const entityDefaults: IConsumerMetadataItem = {
	id: 0,
	creationDate: null,
	updateDate: null,
	login: '',
	firstName: '',
	lastName: '',
	mail: '',
	avatar: null,
	name: '',
	description: '',
	isGroup: false,
};

export class ConsumerMetadataItemEntity implements IConsumerMetadataItem {
	private [immerable] = true;

	public id = entityDefaults.id;
	public avatar = entityDefaults.avatar;
	public creationDate = entityDefaults.creationDate;
	public updateDate = entityDefaults.updateDate;
	public login = entityDefaults.login;
	public firstName = entityDefaults.firstName;
	public lastName = entityDefaults.lastName;
	public mail = entityDefaults.mail;
	public name = entityDefaults.name;
	public description = entityDefaults.description;
	public isGroup = entityDefaults.isGroup;

	public static buildUserMetadata(
		params: Partial<UserConsumerMetadata>
	): ConsumerMetadataItemEntity {
		return new ConsumerMetadataItemEntity({
			id: params.id,
			login: params.login,
			firstName: params.firstName,
			lastName: params.lastName,
			mail: params.mail,
			creationDate: params.creationDate,
			updateDate: params.updateDate,
			isGroup: false,
		});
	}

	public static buildGroupMetadata(
		params: Partial<GroupConsumerMetadata>
	): ConsumerMetadataItemEntity {
		return new ConsumerMetadataItemEntity({
			id: params.id,
			name: params.name,
			description: params.description,
			creationDate: params.creationDate,
			updateDate: params.updateDate,
			isGroup: true,
		});
	}

	private constructor(params: Partial<IConsumerMetadataItem>) {
		this.id = params.id ?? entityDefaults.id;
		this.login = params.login ?? entityDefaults.login;
		this.firstName = params.firstName ?? entityDefaults.firstName;
		this.lastName = params.lastName ?? entityDefaults.lastName;
		this.mail = params.mail ?? entityDefaults.mail;
		this.name = params.name ?? entityDefaults.name;
		this.description = params.description ?? entityDefaults.description;
		this.creationDate = params.creationDate ?? entityDefaults.creationDate;
		this.updateDate = params.updateDate ?? entityDefaults.updateDate;
		this.isGroup = params.isGroup ?? entityDefaults.isGroup;

		this.avatar = params.login
			? AvatarEntity.build(params.login)
			: AvatarEntity.build(`${params.firstName} ${params.lastName}`);
	}
}
